"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IlCard = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
function IlCard(_a) {
    var sx = _a.sx, cardActionAreaSx = _a.cardActionAreaSx, flexBoxSx = _a.flexBoxSx, contentFlexBoxSx = _a.contentFlexBoxSx, leftSx = _a.leftSx, centerSx = _a.centerSx, rightSx = _a.rightSx, footerSx = _a.footerSx, leftContent = _a.leftContent, centerContent = _a.centerContent, rightContent = _a.rightContent, footerContent = _a.footerContent, _b = _a.showFooter, showFooter = _b === void 0 ? false : _b, _c = _a.clickable, clickable = _c === void 0 ? false : _c, key = _a.key, onClick = _a.onClick;
    return (react_1.default.createElement(material_1.Card, { key: key, sx: __assign({ height: '3rem', backgroundColor: 'background.default', boxShadow: 'none', borderWidth: '0.0625rem', borderStyle: 'solid', borderColor: 'secondary.light', padding: '.75rem' }, sx) },
        react_1.default.createElement(material_1.CardActionArea, __assign({ disabled: !clickable, onClick: onClick, sx: __assign({ '&:hover': {
                    backgroundColor: 'action.disabledBackground',
                }, boxSizing: 'content-box' }, cardActionAreaSx) }, (!clickable && {
            component: 'div',
        })),
            react_1.default.createElement(material_1.Box, { sx: __assign({ display: 'flex', height: '100%', flexDirection: 'column' }, flexBoxSx) },
                react_1.default.createElement(material_1.Box, { sx: __assign({ display: 'flex', flexDirection: 'row', height: '2rem', justifyContent: 'space-between' }, contentFlexBoxSx) },
                    react_1.default.createElement(material_1.Box, { sx: { display: 'flex', flexDirection: 'row' } },
                        react_1.default.createElement(material_1.Box, { "data-testid": 'left-panel', sx: __assign({ width: '2rem' }, leftSx) }, leftContent),
                        react_1.default.createElement(material_1.Box, { "data-testid": 'center-panel', sx: __assign({ width: '100%' }, centerSx) }, centerContent)),
                    react_1.default.createElement(material_1.Box, { "data-testid": 'right-panel', sx: __assign({ width: '2rem' }, rightSx) }, rightContent)),
                showFooter && (react_1.default.createElement(material_1.Box, { "data-testid": 'footer-panel', sx: __assign({ height: '1rem' }, footerSx) }, footerContent))))));
}
exports.IlCard = IlCard;
